export default function normalizeInviteCode(code: string) {
  return code.replace(/[\s-]+/g, '').toUpperCase();
}
